import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faHeadset } from "@fortawesome/free-solid-svg-icons";
import { Button } from "antd";
import logo from "../Assets/Logo/logo.png";
import ProfileMenu from "Pages/Settings/ProfileMenu";

function MainLayout(props) {
  const location = useLocation();
  const navigate = useNavigate();

  // Check if we're on the dashboard page
  const isDashboard = location.pathname === "/dashboard";

  const handleBackClick = () => {
    navigate("/dashboard");
  };

  return (
    <div className="h-full flex flex-col duration-300 transition bg-gray-100">
      <div className="flex justify-between items-center p-4 px-5">
        <div className="flex items-center gap-3">
          {!isDashboard && (
            <button
              onClick={handleBackClick}
              className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
              aria-label="Back to Dashboard">
              <FontAwesomeIcon
                icon={faArrowLeft}
                className="text-gray-600 text-sm"
              />
            </button>
          )}
          <div className="flex items-center gap-2">
            <img src={logo} alt="InProfile Logo" className="w-8 h-8" />
            <div className="text-base font-bold">InProfile</div>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <Button
            type="text"
            className="flex items-center gap-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg px-3 py-2"
            onClick={() => navigate("/contact-support")}>
            <FontAwesomeIcon icon={faHeadset} className="text-sm" />
            <span className="text-sm font-medium">Help</span>
          </Button>
          <ProfileMenu />
        </div>
      </div>
      <div className="flex-1">{props?.children}</div>
    </div>
  );
}

export default MainLayout;
